import { useCallback, useEffect, useState } from "react";
import { IPagination } from "../../../types/pagination";
import { useContextSite } from "../../../context/Context";
import { useMediaQuery } from "react-responsive";
import { Denuncia } from "../../../services/Denuncias";
import { toast } from "react-toastify";
import { IDenunciaDTO, IGetDenunciaProps } from "../../../types/denuncia";
import { TIPOS_ASSEDIO } from "../../../constants/denuncia";
import { useNavigate } from "react-router-dom";

const ASSEDIO_OPTIONS = Object.values(TIPOS_ASSEDIO).map((tipo) => ({
  label: tipo,
  value: tipo,
}));
export const useComplaints = () => {
  const [data, setData] = useState<IDenunciaDTO[]>([]);
  const navigate = useNavigate();
  const { setIsLoad } = useContextSite();
  const isMobile = useMediaQuery({ maxWidth: "640px" });
  const [pagination, setPagination] = useState<IPagination>({} as IPagination);
  const [numberPage, setNumberPage] = useState(0);
  const [filter, setFilter] = useState<IGetDenunciaProps>({});

  function getDenuncias(props?: IGetDenunciaProps) {
    setIsLoad(true);
    Denuncia.get({ page: numberPage + 1, page_size: 5, ...props })
      .then((res) => {
        setData(res.data.results);
        setPagination({
          actualPage: numberPage,
          totalRegister: res.data.count,
          totalPage: Math.ceil(res.data.count / 5),
        });
      })
      .catch((err) => {
        toast.error("Erro ao buscar denúncias.");
      })
      .finally(() => {
        setIsLoad(false);
      });
  }

  useEffect(() => {
    getDenuncias(filter);
  }, [numberPage]);

  function handleFilter(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setNumberPage(0);
    getDenuncias(filter);
  }

  return {
    data,
    setNumberPage,
    pagination,
    isMobile,
    setFilter,
    filter,
    ASSEDIO_OPTIONS,
    handleFilter,
    navigate,
  };
};
